module.exports = __webpack_public_path__ + "static/img/portable-miner_256.15a6dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portable-miner_256.png
// module id = esT3
// module chunks = 0